import { useState } from 'react';
import { Button } from 'src/@/components/ui/button';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from 'src/@/components/ui/popover';
import Iconify from 'src/components/Iconify';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { useSnackbar } from 'notistack';
import v2_actionEditarLead from 'src/actions/v2/crm/v2_actionEditarLead';

// ----------------------------------------------------------------------

export default function ComponentCloseLead({ user, lead, onCallback, onOpen, open, onOpenChange }) {
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    async function editarLead(value) {
        try {
            // Sem conversão marcada não há o que finalizar — o negócio precisa
            // ter desfecho (venda/perda) antes de ser encerrado.
            if (lead.convertido === null) {
                enqueueSnackbar('Não é possível finalizar o negócio, pois o lead ainda não foi convertido.', {
                    variant: 'error',
                    autoHideDuration: 3000,
                    anchorOrigin: { vertical: 'bottom', horizontal: 'left' }
                });
                return;
            }

            let data = {
                action: "finalizar_negocio",
                scope: {
                    closed: value,
                    data_finalizacao: new Date()
                }
            };
            setLoading(true);
            await v2_actionEditarLead(lead._id, data, user.id);
            onCallback();
            setLoading(false);
            enqueueSnackbar('Negócio finalizado com sucesso', {
                variant: 'success',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' }
            });
        } catch (error) {
            setLoading(false);
            console.log('error', error);
            enqueueSnackbar('Erro ao finalizar negócio', {
                variant: 'error',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' }
            });
        }
    }

    return (
        <Popover open={open} onOpenChange={onOpenChange}>
            <PopoverTrigger asChild>
                <Button
                    className="h-8 w-8"
                    size="icon"
                    onClick={onOpen}
                    variant="outline"
                    title="Finalizar negócio"
                    aria-label="Finalizar negócio"
                >
                    <Iconify icon="lets-icons:flag-finish" width={16} />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-80 z-[9999] rounded-xl dark:bg-[#222529] dark:border-[#383838]">
                <div className="flex items-center gap-2.5 mb-3">
                    <div className="w-8 h-8 rounded-lg bg-violet-50 dark:bg-violet-500/10 flex items-center justify-center shrink-0">
                        <Iconify icon="lets-icons:flag-finish" width={16} className="text-violet-600 dark:text-violet-400" />
                    </div>
                    <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">Finalizar negócio</p>
                </div>
                {lead.convertido ? (
                    <div className="flex flex-col gap-4">
                        <p className="text-[13px] text-gray-600 dark:text-[#ABABAD]">
                            Deseja realmente finalizar esse negócio? Ele deixará de aparecer no funil ativo.
                        </p>
                        <div className="flex gap-2">
                            <Button variant="outline" className="flex-1" onClick={() => onOpenChange()}>Cancelar</Button>
                            <ButtonLoading
                                loading={loading}
                                onClick={() => editarLead(true)}
                                className="flex-1 bg-[#7C3AED] hover:bg-[#6d28d9]"
                            >
                                {loading ? 'Finalizando...' : 'Finalizar'}
                            </ButtonLoading>
                        </div>
                    </div>
                ) : (
                    <p className="text-[13px] text-gray-600 dark:text-[#ABABAD]">
                        Marque como <span className="font-bold">perda</span> ou <span className="font-bold">venda</span> antes de finalizar o negócio.
                    </p>
                )}
            </PopoverContent>
        </Popover>
    );
}
